export default __webpack_public_path__ + "static/flipImg2-91dd44e3169389ba51208be57d431844.webp";